// 引入通用common
import commons from '@/util/commons';
import { EventBus } from '@/util/eventBus'; // 引入事件总线
import * as types from '@/store/types';
import {
  apiUserlogin,
  apiUserinfo,
  apiDepartment,
  apiRole,
  apiUsermodify,
  apiUserlogs,
  apiUserlists,
  apiUserdel,
  apiUserstore,
  apiUsercontrolstore,
  apiUsercontrolmodify,
  apiUsercontrol,
  apiUsercontroldel,
  apiUserall,
  apiUsercontrolinfo,
  apiRolestore,
  apiRolemodify,
  apiRolelists,
  apiRoledel,
  apiRoleinfo,
  apiUserlogsalls,
  apiUsercolleague,
  apiUsercolleaguemodify,
  apiUsercolleagueinfo,
  apiTagesalls,
  apiTagesdel,
  apiTagesmodify,
  apiTagesstore,
  apiTagesinfo,
  apiResumetagesalls,
  apiResumetagesdel,
  apiResumetagesmodify,
  apiResumetagesstore,
  apiResumetagesinfo,
  apiResumetagesArr,
  apiResumepositionArr,
  apiResumelist,
  apiResumeliststore,
  apiResumelistinfo,
  apiResumelistmodify,
  apiResumeRefreshlist,
  apiResumelistdel,
  apiResumeinterview,
  apiResumeinterviewstore,
  apiResumeinterviewdel,
  apiResumetrace,
  apiResumetracestore,
  apiResumeworktable,
  apiSignevent,
  apiSigneventusers,
  apiResumeinterviewrefreshlist,
  apiSigneventstore,
  apiSigneventinfo,
  apiSigneventmodify,
  apiSigneventdel,
  apiSignlog,
  apiSignloginfo,
  apiSigneventjoinlist,
  apiStatisticsvisitmy,
  apiStatisticsvisitmyline,
  apiStatisticsvisitall,
  apiStatisticsvisitallline,
  apiUsernotice,
  apiUsernoticestore,
  apiUsernoticeinfo,
  apiUsernoticemodify,
  apiUsernoticedel,
  apiUsercontacts,
  apiUsercontactsstore,
  apiUsercontactsinfo,
  apiUsercontactsmodify,
  apiUsercontactsdel,
  apiMemo,
  apiMemostore,
  apiMemoinfo,
  apiMemomodify,
  apiMemodel,
  apiMessage,
  apiMessagestate,
  apiStatisticshome,
  apiCrmlist,
  apiCrmTages,
  apiCrmLogs,
  apiCrmInfo,
  apiCrmTrace,
  apiCrmTraceLabel,
  apiUserZaizhi,
  apiCrmTracestore,
  apiCrmModify,
  apiCrmContact,
  apiCrmContactStore,
  apiCrmContactDel
  ,
  apiCrmPact,
  apiCrmPactStore,
  apiCrmPactDel,
  apiCrmPactTages,
  apiCrmFiles,
  apiCrmFilesStore,
  apiCrmFilesDel,

  apiCrmFinance,
  apiCrmFinanceStore,
  apiCrmFinanceDel,

  apiCrmShare,
  apiCrmDutyuid,
  apiCrmSetchance,
  apiCrmSetclient,
  apiCrmDel,
  apiCrmBlackapply,
  apiCrmProtect,
  apiCrmSetlatent,
  apiCrmStore,
  apiUpdatetoken,
  apiCrmRecover,
  apiCrmblackstore,
  apiCrmblackmodify,
  apiCrmblacklists,
  apiCrmblackdel,
  apiCrmblackstate,
  apiCrmblackinfo,
  apiStatisticscrmchancehome,
  apiStatisticscrmchancedataone,
  apiStatisticscrmchancedatatow,
  apiStatisticscrmdataone,
  apiStatisticscrmdatatow,
  apiStatisticscrmdatathree,
  apiStatisticscrmdatafour,
  apiStatisticscrmdatafive,
  apiCrmPactInfo,
  apiCrmPactTrace,
  apiCrmPactTracestore,
  apiCrmPactFilesStore,
  apiCrmPactFilesDel,
  apiCrmPactFiles,
  apiCrmImport,
  apiCrmImportshow,
  apiStatisticscrmdatahome,
  apiUsertongshi,
  apiCrmviewcontact,
  apiStatisticsviewlogs,
  apiViewlogs,
  apiCrmmap,
  apiNodealls,
  apiSignbinding,
  apiBindinginfo,
  apiSignfindtoken,
  apiSignmakeqrcode,
  apiExternalsign,
  apiExternalsigninfo,
  apiCrmdestroy,
  apiCrmTracedel,
  apiCrmsavezhuangtai,
  apiCrmcontactrepeat,
  apiStatisticscrmdatatowss,
  apiCrmblackphonerepeat,
  apiCrmFinanceCatearr,
  apiCrmfinancedanwei,
  apiSetmemoalert,
  apiSetmemo,
  apiLogincode,
  apiCrmlistWeilianxi,
  apiSignloggenjinren,
  apiCrmShoucifenpeiTrace,
  apiStatisticscrmdatashoucifenpei,
} from '../request/api';

export default {
  apiLogin(that, ob) {
    const skip = ob.skip;
    // 遮罩
    EventBus.$emit('globalZhezhaoBoxFun', true);
    // 加载中
    that.isLoading = true;
    // 鉴权号
    if (!ob.k) {
      ob.k = that.$route.query.k;
    }
    // 获取完整网址
    ob.url = window.location.href;
    // 发起请求
    return apiUserlogin(ob).then((ob) => {
      if (ob.state === 200) {
        // 初始化时间戳
        let times;
        // 执行写入本地 保持登录1天
        if (that.isCheck) {
          // 保持7天
          times = 60 * 60 * 24 * 7 * 1000;
          // times = 60 * 60 * 24 * 1000;
        } else {
          // 保持1天
          times = 60 * 60 * 24 * 1000;
        }
        // 写入缓存
        const result = commons.saveTodos('localUser', ob.data, times, 0);
        // 存储结果
        if (result) {
          // 更新本地路由的登录信息
          that.$store.commit(types.SAVE_LOCALUSER, { bool: true });
          if (skip) {
            // 跳转路由
            window.location.replace(`/home?t=${Date.now()}`);
            // that.$router.push({ path: '/home', query: { t: Date.now() } });
          }
          // 取消遮罩
          EventBus.$emit('globalZhezhaoBoxFun', false);
          // 取消加载
          that.isLoading = false;
          // 登陆成功
          that.$message.showMsgBox({ type: 'success', content: '登陆成功' });
        } else {
          // 登陆失败
          that.$message.showMsgBox({ type: 'warning', content: '登陆失败' });
          // 取消遮罩
          EventBus.$emit('globalZhezhaoBoxFun', false);
          // 取消加载
          that.isLoading = false;
        }
      } else {
        // 登陆失败
        that.$message.showMsgBox({ type: 'warning', content: ob.message });
        // 取消遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 取消加载
        that.isLoading = false;
      }
      return ob;
    }).catch((ob) => {
      // 登陆失败
      that.$message.showMsgBox({ type: 'warning', content: '网络失败' });
      // 取消遮罩
      EventBus.$emit('globalZhezhaoBoxFun', false);
      // 取消加载
      that.isLoading = false;
      return { state: 201, message: '网络错误' };
    });
  },
  // 用户基本信息
  apiUserinfo(that, ob) {
    return apiUserinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiLogincode(that, ob) {
    return apiLogincode(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 部门列表
  apiDepartment(that, ob) {
    return apiDepartment(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 角色列表
  apiRole(that, ob) {
    return apiRole(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改个人信息
  apiUsermodify(that, ob) {
    return apiUsermodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 添加账号
  apiUserstore(that, ob) {
    return apiUserstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改个人信息
  apiUserdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiUserdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiUserlists(that, obj) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiUserlists(obj).then((ob) => {
      if (ob.state === 200) {
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 登录日志
  apiUserlogs(that, obj) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiUserlogs(obj).then((ob) => {
      if (ob.state === 200) {
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiUserall(that, ob) {
    return apiUserall(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsercontrolinfo(that, ob) {
    return apiUsercontrolinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改个人信息
  apiUsercontrolmodify(that, ob) {
    return apiUsercontrolmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 添加账号
  apiUsercontrolstore(that, ob) {
    return apiUsercontrolstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改个人信息
  apiUsercontroldel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiUsercontroldel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiUsercontrollists(that, obj) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiUsercontrol(obj).then((ob) => {
      if (ob.state === 200) {
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiRoleinfo(that, ob) {
    return apiRoleinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改个人信息
  apiRolemodify(that, ob) {
    return apiRolemodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 添加账号
  apiRolestore(that, ob) {
    return apiRolestore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改个人信息
  apiRoledel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiRoledel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiUserlogsalls(that, obj) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiUserlogsalls(obj).then((ob) => {
      if (ob.state === 200) {
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 账号列表
  apiRolelists(that, obj) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiRolelists(obj).then((ob) => {
      if (ob.state === 200) {
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 添加账号
  apiUsercolleague(that, ob) {
    return apiUsercolleague(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsercolleagueinfo(that, ob) {
    return apiUsercolleagueinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsercolleaguemodify(that, ob) {
    return apiUsercolleaguemodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiTagesalls(that, ob) {
    return apiTagesalls(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiTagesdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiTagesdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiTagesmodify(that, ob) {
    return apiTagesmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiTagesstore(that, ob) {
    return apiTagesstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiTagesinfo(that, ob) {
    return apiTagesinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiResumetagesalls(that, ob) {
    return apiResumetagesalls(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumetagesdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiResumetagesdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiResumetagesmodify(that, ob) {
    return apiResumetagesmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumetagesstore(that, ob) {
    return apiResumetagesstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumetagesinfo(that, ob) {
    return apiResumetagesinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiResumetagesArr(that, ob) {
    return apiResumetagesArr(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumepositionArr(that, ob) {
    return apiResumepositionArr(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiResumelist(that, obj) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiResumelist(obj).then((ob) => {
      if (ob.state === 200) {
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiResumeliststore(that, ob) {
    return apiResumeliststore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumelistmodify(that, ob) {
    return apiResumelistmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumelistinfo(that, ob) {
    return apiResumelistinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumeRefreshlist(that, ob) {
    return apiResumeRefreshlist(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumelistdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiResumelistdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiResumeinterview(that, ob) {
    return apiResumeinterview(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumeinterviewstore(that, ob) {
    return apiResumeinterviewstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumeinterviewdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiResumeinterviewdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiResumetrace(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiResumetrace(obj).then((ob) => {
      if (ob.state === 200) {
        // 请求成功了
        if (reload) {
          that.data = ob.data.list;
        } else {
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
        }
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiResumetracestore(that, ob) {
    return apiResumetracestore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiResumeinterviewlist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiResumeinterview(obj).then((ob) => {
      if (ob.state === 200) {
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiResumeworktable(that, ob) {
    return apiResumeworktable(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiSignevent(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiSignevent(obj).then((ob) => {
      if (ob.state === 200) {
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiSigneventusers(that, ob) {
    return apiSigneventusers(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiResumeinterviewrefreshlist(that, ob) {
    return apiResumeinterviewrefreshlist(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSigneventstore(that, ob) {
    return apiSigneventstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSigneventinfo(that, ob) {
    return apiSigneventinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSigneventmodify(that, ob) {
    return apiSigneventmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSigneventdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiSigneventdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiSignlog(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiSignlog(obj).then((ob) => {
      if (ob.state === 200) {
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiSignloginfo(that, ob) {
    return apiSignloginfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiSignloggenjinren(that, ob) {
    return apiSignloggenjinren(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiSigneventjoinlist(that, ob) {
    return apiSigneventjoinlist(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticsvisitmy(that, ob) {
    return apiStatisticsvisitmy(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticsvisitmyline(that, ob) {
    return apiStatisticsvisitmyline(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticsvisitall(that, ob) {
    return apiStatisticsvisitall(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticsvisitallline(that, ob) {
    return apiStatisticsvisitallline(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiUsernotice(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiUsernotice(obj).then((ob) => {
      if (ob.state === 200) {
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiUsernoticestore(that, ob) {
    return apiUsernoticestore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsernoticeinfo(that, ob) {
    return apiUsernoticeinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsernoticemodify(that, ob) {
    return apiUsernoticemodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsernoticedel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiUsernoticedel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiUsercontacts(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiUsercontacts(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.dataA = [];
          that.dataB = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          if (item.type === '1') {
            that.dataA.push(item);
          } else {
            that.dataB.push(item);
          }
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.dataA = [];// 清空
          that.dataB = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiUsercontactsstore(that, ob) {
    return apiUsercontactsstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsercontactsinfo(that, ob) {
    return apiUsercontactsinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSetmemoalert(that, ob) {
    return apiSetmemoalert(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSetmemo(that, ob) {
    return apiSetmemo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsercontactsdel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiUsercontactsdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiMemo(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiMemo(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiMemostore(that, ob) {
    return apiMemostore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiMemoinfo(that, ob) {
    return apiMemoinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiMemomodify(that, ob) {
    return apiMemomodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiMemodel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiMemodel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiMessage(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiMessage(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiMessagestate(that, ob) {
    return apiMessagestate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticshome(that, ob) {
    return apiStatisticshome(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmTages(that, ob) {
    return apiCrmTages(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiCrmlistWeilianxi(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiCrmlistWeilianxi(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 账号列表
  apiCrmlist(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiCrmlist(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 账号列表
  apiCrmLogs(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiCrmLogs(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmInfo(that, ob) {
    return apiCrmInfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },


  // 账号列表
  apiCrmShoucifenpeiTrace(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiCrmShoucifenpeiTrace(obj).then((ob) => {
      that.diffuser = ob.data.diffuser;
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.clientNumber = ob.data.clientNumber;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.clientNumber = 0;
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  // 账号列表
  apiCrmTrace(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiCrmTrace(obj).then((ob) => {
      that.diffuser = ob.data.diffuser;
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.clientNumber = ob.data.clientNumber;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.clientNumber = 0;
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 账号列表
  apiViewlogs(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiViewlogs(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.clientNumber = ob.data.clientNumber;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.clientNumber = 0;
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmTraceLabel(that, ob) {
    return apiCrmTraceLabel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUserZaizhi(that, ob) {
    return apiUserZaizhi(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmTracestore(that, ob) {
    return apiCrmTracestore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmModify(that, ob) {
    return apiCrmModify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiCrmContact(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiCrmContact(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmContactStore(that, ob) {
    return apiCrmContactStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmContactDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmContactDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  // 账号列表
  apiCrmPact(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiCrmPact(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmPactStore(that, ob) {
    return apiCrmPactStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmPactDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmPactDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmPactTages(that, ob) {
    return apiCrmPactTages(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiCrmFiles(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiCrmFiles(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmFilesStore(that, ob) {
    return apiCrmFilesStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmFilesDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmFilesDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },


  // 账号列表
  apiCrmFinance(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiCrmFinance(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmFinanceStore(that, ob) {
    return apiCrmFinanceStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmFinanceCatearr(that, ob) {
    return apiCrmFinanceCatearr(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmfinancedanwei(that, ob) {
    return apiCrmfinancedanwei(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiCrmFinanceDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmFinanceDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },


  apiCrmShare(that, ob) {
    return apiCrmShare(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmDutyuid(that, ob) {
    return apiCrmDutyuid(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmSetchance(that, ob) {
    return apiCrmSetchance(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmSetclient(that, ob) {
    return apiCrmSetclient(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmBlackapply(that, ob) {
    return apiCrmBlackapply(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmProtect(that, ob) {
    return window.swal({
      title: '确定转换吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmProtect(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmSetlatent(that, ob) {
    return apiCrmSetlatent(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmStore(that, ob) {
    return apiCrmStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUpdatetoken(that, ob) {
    return apiUpdatetoken(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmRecover(that, ob) {
    return apiCrmRecover(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiBindinginfo(that, ob) {
    return apiBindinginfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiCrmblacklists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiCrmblacklists(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmblackdel(that, ob) {
    return window.swal({
      title: '确定转换吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmblackdel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmblackstore(that, ob) {
    return apiCrmblackstore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmblackmodify(that, ob) {
    return apiCrmblackmodify(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmblackinfo(that, ob) {
    return apiCrmblackinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmchancehome(that, ob) {
    return apiStatisticscrmchancehome(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmchancedataone(that, ob) {
    return apiStatisticscrmchancedataone(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmchancedatatow(that, ob) {
    return apiStatisticscrmchancedatatow(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdataone(that, ob) {
    return apiStatisticscrmdataone(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdatatow(that, ob) {
    return apiStatisticscrmdatatow(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdatathree(that, ob) {
    return apiStatisticscrmdatathree(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdatafour(that, ob) {
    return apiStatisticscrmdatafour(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdatafive(that, ob) {
    return apiStatisticscrmdatafive(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmPactInfo(that, ob) {
    return apiCrmPactInfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiCrmPactTrace(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiCrmPactTrace(obj).then((ob) => {
      that.diffuser = ob.data.diffuser;
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmPactTracestore(that, ob) {
    return apiCrmPactTracestore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 账号列表
  apiCrmPactFiles(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiCrmPactFiles(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败',
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败',
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmPactFilesStore(that, ob) {
    return apiCrmPactFilesStore(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmPactFilesDel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmPactFilesDel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmdestroy(that, ob) {
    return window.swal({
      title: '确定销毁吗?',
      text: '销毁客户数据及所有相关联的数据及文件',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        that.isSearchLoading = true;
        return apiCrmdestroy(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmTracedel(that, ob) {
    return window.swal({
      title: '确定删除吗?',
      text: '删除这条跟进记录',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmTracedel(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmsavezhuangtai(that, ob) {
    return window.swal({
      title: '确定修改吗?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        return apiCrmsavezhuangtai(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
      }
      return { state: 201, message: '取消成功' };
    });
  },
  apiCrmcontactrepeat(that, ob) {
    return apiCrmcontactrepeat(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmblackphonerepeat(that, ob) {
    return apiCrmblackphonerepeat(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmImport(that, ob) {
    return apiCrmImport(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmImportshow(that, ob) {
    return apiCrmImportshow(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdatahome(that, ob) {
    return apiStatisticscrmdatahome(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiUsertongshi(that, ob) {
    return apiUsertongshi(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmviewcontact(that, ob) {
    return apiCrmviewcontact(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticsviewlogs(that, ob) {
    return apiStatisticsviewlogs(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCrmmap(that, ob) {
    return apiCrmmap(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiNodealls(that, ob) {
    return apiNodealls(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSignbinding(that, ob) {
    return apiSignbinding(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSignfindtoken(that, ob) {
    return apiSignfindtoken(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSignmakeqrcode(that, ob) {
    return apiSignmakeqrcode(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiExternalsign(that, ob) {
    return apiExternalsign(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiExternalsigninfo(that, ob) {
    return apiExternalsigninfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiStatisticscrmdatatowss(that, ob) {
    return apiStatisticscrmdatatowss(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },

  apiStatisticscrmdatashoucifenpei(that, ob) {
    return apiStatisticscrmdatashoucifenpei(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
};



// WEBPACK FOOTER //
// ./src/util/resultcommons.js